// Copyright (c) 2016 Deere & Company

import Views, {getDefaultState} from '../state/views';
import actions from '../../actions-list';

function updateRegistrationReviewViews(state, action) {

    return Views.update(state, {
        $set: [
            {
                ...state[0],
                sortBy: action.sortBy
            }
        ]
    });

}

const resetRegistrationReviewViews = () => getDefaultState();

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_REGISTRATIONS_REVIEW_VIEWS]: resetRegistrationReviewViews,
        [actions.UPDATE_REGISTRATIONS_REVIEW_VIEWS]: updateRegistrationReviewViews

    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/registrations-review/reducers/views.js